// @ts-nocheck
const copyBtn = document.getElementById("js-mail-knowledge-mail-address-copy");
if (copyBtn) {
  copyBtn.addEventListener("click", function () {
    function showTemp() {
      const iconDefault = document.querySelector(".js-mail-knowledge-copy-btn");
      const iconTemp = document.querySelector(".js-mail-knowledge-copy-temp");
      iconDefault.style.display = "none";
      iconTemp.style.display = "block";
    }

    const email =
      document.getElementById("mail_knowledge_data_source_custom_email").value +
      document.querySelector(".js-mail-knowledge-mail-address").textContent;

    if (navigator.clipboard === undefined) {
      window.clipboardData.setData("Text", email);
      showTemp();
    } else {
      navigator.clipboard.writeText(email).then(showTemp());
    }

    setTimeout(function () {
      const iconDefault = document.querySelector(".js-mail-knowledge-copy-btn");
      const iconTemp = document.querySelector(".js-mail-knowledge-copy-temp");
      iconDefault.style.display = "block";
      iconTemp.style.display = "none";
    }, 1000);
  });
}
